import { FormControl, FormControlLabel, Radio } from "@mui/material";
import TranslationGuard, { extractHTMLTextContent }  from "../PageUtils/User/TranslationGuard";
import { useMemo } from "react";

const MultiChoiceQuestion = ({
  id,
  question_text,
  options,
  selectedOptionId,
  onResponse
}) => {
  const handleOptionChange = event => {
    const selectedResponse = event.target.value;
    onResponse({ questionID: id, response: selectedResponse });
  };

  const questionRawHtml = question_text.replace(/\n/g, "<br>").replace("\\n", "<br>")
  const question_html =
    '<h3 style={{ marginBottom: "1rem", textAlign: "right", translate: "no" }}><div id="questionText" dir="rtl" style={{ translate: "no" }}>' +
    questionRawHtml +
    "</div></h3>";

  const expectedTexts = useMemo(() => {
    const map = { "#questionText": extractHTMLTextContent(questionRawHtml) }
    options.map(option => (
      map["#option_" + option.id] = extractHTMLTextContent(option.text)
    ));
    return map
  }, [id]);

  return (
    <div style={{ textAlign: "right" }}>
      <div dangerouslySetInnerHTML={{ __html: question_html }} />
      <FormControl component="fieldset">
        {options.map(option => (
          <FormControlLabel
            key={option.id}
            control={<Radio color="primary" />}
            labelPlacement="start"
            label={
              <div style={{ display: "flex", justifyContent: "flex-end", translate: "no" }}>
                <div id={"option_" + option.id} dangerouslySetInnerHTML={{ __html: option.text }} />
              </div>
            }
            value={option.id}
            checked={option.id == selectedOptionId}
            onChange={handleOptionChange}
            style={{ marginBottom: "0.5rem" }}
          />
        ))}
      </FormControl>

      {TranslationGuard(expectedTexts)}
    </div>
  );
};
export default MultiChoiceQuestion;
